var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98462 0.64031L2.23727 3.49074L1.1563 2.05108C1.00683 1.85259 0.715903 1.80485 0.505047 1.94555C0.294192 2.08625 0.244814 2.36011 0.392947 2.5586L1.76217 4.38142C1.83691 4.48066 1.95168 4.54599 2.07979 4.56357C2.10114 4.56609 2.1225 4.56734 2.14385 4.56734C2.25061 4.56734 2.35337 4.53342 2.43744 4.46936L6.57315 1.32497C6.77333 1.17296 6.80536 0.895328 6.64254 0.706891C6.47973 0.517197 6.18614 0.488304 5.98462 0.64031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correctIcon.677805308674f5e15b0edd2340210ccc.svg";
export { ForwardRef as ReactComponent };